<template>
  <WidgetBase
    :title="title"
    :title-link="titleLink"
  >
    <template #action>
      <el-button
        type="primary"
        size="default"
        @click="$emit('action')"
        >{{ actionLabel }}</el-button
      >
    </template>
    <div class="indicator">
      <el-row
        v-for="(indicator, index) in indicators"
        :key="index"
        class="indicator-row"
        :gutter="10"
      >
        <el-col :span="12">
          <el-text tag="b">{{ indicator.label }}</el-text>
        </el-col>
        <el-col :span="12">
          <div
            class="el-text el-text--small value"
            :class="{
              'el-text--success': indicator.type === 'success',
              'el-text--warning': indicator.type === 'warning',
              'el-text--danger': indicator.type === 'danger',
            }"
          >
            {{ indicator.value }}
          </div>
        </el-col>
      </el-row>
    </div>
  </WidgetBase>
</template>

<script setup>
import WidgetBase from './base.vue';

const props = defineProps({
  title: String,
  actionLabel: String,
  titleLink: String,
  indicators: Array,
});
</script>

<style scoped>
.indicator {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

@media (max-width: 767px) {
  .indicator {
    margin-top: 1rem;
  }

  .indicator-row {
    margin-bottom: 6px;
  }
}

.value {
  text-align: right;
  font-weight: 700;
  font-size: 0.9em;
}
</style>
